<div class="header-container">
  <div
    data-test="header-content"
    class="header-content"
    [ngClass]="{ 'buttons-displayed': isButtonsDisplayed }"
  >
    <div class="logo-content">
      <a
        routerLink="/"
        routerLinkActive="active"
        class="logo"
        floAnalytics
        tabindex="0"
        [ngClass]="{ 'buttons-displayed': isButtonsDisplayed }"
      >
        <flo-svg-logo [siteId]="siteId"></flo-svg-logo>
      </a>
    </div>
    <div class="action-content" *ngIf="isButtonsDisplayed">
      <button
        *ngIf="isLoginDisplayed"
        class="btn btn-sm btn-transparent btn-dark login"
        data-test="login-button"
        (click)="handleClickLogin()"
      >Log In</button>
      <button
        *ngIf="isSignupDisplayed"
        class="btn btn-sm btn-primary signup fade-in"
        data-test="signup-button"
        (click)="handleClickSignup()"
      >Sign Up</button>
    </div>
  </div>
</div>
